export default function back(history){
    if (window.history.length <= 1) {
        history.replace('/');
    } else {
        history.goBack();
    }
}
